export const radians = Math.PI / 180;
export const degrees = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// /srv/http/murdocktrust.org/releases/458/web/app/themes/murdock-serenity/node_modules/d3-color/src/math.js
// module id = 125
// module chunks = 0